(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mtij-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mtij-sticky-atc')) {
    class MtijStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.formId = this.querySelector('[data-msa-submit]')?.getAttribute('form');

        const productInfo = document.getElementById('MainProduct-' + this.sectionId);
        const buyButtons = productInfo
          ? productInfo.querySelector('.product-form__buttons')
          : null;

        if (!buyButtons) {
          // No reference point to compare against — keep hidden.
          return;
        }

        this.hidden = false;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const buyButtonsAboveViewport = entry.boundingClientRect.bottom < 0;
              if (buyButtonsAboveViewport) {
                this.classList.add('is-visible');
              } else {
                this.classList.remove('is-visible');
              }
            });
          },
          { threshold: 0, rootMargin: '0px 0px -100% 0px' }
        );
        observer.observe(buyButtons);

        this.bindLivePriceUpdates();
      }

      bindLivePriceUpdates() {
        const priceEl = this.querySelector('[data-msa-price]');
        const submitBtn = this.querySelector('[data-msa-submit]');
        const labelAvailable = this.querySelector('[data-msa-label-available]');
        const labelUnavailable = this.querySelector('[data-msa-label-unavailable]');
        if (!priceEl || !submitBtn) return;

        const productInfo = document.getElementById('MainProduct-' + this.sectionId);
        if (!productInfo) return;

        const syncPrice = () => {
          const sourcePrice = productInfo.querySelector(`#price-${this.sectionId} .price`);
          if (sourcePrice) {
            priceEl.innerHTML = sourcePrice.outerHTML;
          }
        };

        productInfo.addEventListener('change', () => {
          syncPrice();
          const liveBuyBtn = productInfo.querySelector('.product-form__submit');
          if (liveBuyBtn) {
            const isDisabled = liveBuyBtn.hasAttribute('disabled');
            submitBtn.disabled = isDisabled;
            if (labelAvailable) labelAvailable.hidden = isDisabled;
            if (labelUnavailable) labelUnavailable.hidden = !isDisabled;
          }
        });
      }
    }

    customElements.define('mtij-sticky-atc', MtijStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
